import { render } from "./MatchingHome.vue?vue&type=template&id=303bd3de&scoped=true&ts=true&lang=pug"
import script from "./MatchingHome.vue?vue&type=script&lang=ts"
export * from "./MatchingHome.vue?vue&type=script&lang=ts"

import "./MatchingHome.vue?vue&type=style&index=0&id=303bd3de&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303bd3de"]])

export default __exports__